import React from 'react';
import { Search } from 'lucide-react';

const Header = ({ title, onSearch, showSearch = false }) => {
  return (
    <header className="bg-white border-b border-gray-200 px-8 py-5 mb-8 shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 tracking-tight">{title}</h2>
          <div className="h-1 w-16 bg-primary-600 rounded-full mt-2"></div>
        </div>

        {showSearch && (
          <div className="flex items-center gap-4">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="text"
                placeholder="Rechercher un document..."
                onChange={(e) => onSearch && onSearch(e.target.value)}
                className="pl-10 pr-4 py-2.5 border border-gray-300 bg-white text-gray-900 placeholder-gray-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 w-80 transition-all"
              />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
